import { Text } from '@jfs/ui-new'
import { NavigationContainer, NavigationIndependentTree } from '@react-navigation/native'
import { createStackNavigator } from '@react-navigation/stack'
import { FC } from 'react'
import { pages } from '../../utils/constants'
import Card from '../EMI/Card'
import { SavedCard } from '../EMI/SavedCard'
import { PaymentProcessing } from '../PaymentProcesseing'
import { JioPayFinanceHub } from './JioFinanceHub'
import { CheckEligibilityScreen } from './screens/CheckEligibilityScreen'
import { EligibleBankList } from './screens/EligibleBankList'
import { ProceedToPayment } from './screens/ProceedToPayment'
import { SelectEmiPlans } from './screens/SelectEmiPlans'

const Stack = createStackNavigator()

const JioFinanceHubStack: FC = (props: any) => {
  return (
    <NavigationIndependentTree>
      <NavigationContainer
        ref={props.navigationRef}
        onReady={props.onReady}
        onStateChange={props.onStateChange}
        {...props}
        independent={true}
        fallback={<Text>Loading...</Text>}>
        <Stack.Navigator screenOptions={{ headerShown: false, cardStyle: { backgroundColor: '#FFF' } }}>
          <Stack.Screen name={pages.jioFinanceHub} component={JioPayFinanceHub} />
          <Stack.Screen name={pages.checkEligibility} component={CheckEligibilityScreen} />
          <Stack.Screen name={pages.eligibleBankList} component={EligibleBankList} />
          <Stack.Screen name={pages.selectEmiPlans} component={SelectEmiPlans} />
          <Stack.Screen name={pages.proceedToPayment} component={ProceedToPayment} />
          <Stack.Screen name={pages.paymentProcessing} component={PaymentProcessing} />
          <Stack.Screen name={pages.emiSavedCard} component={SavedCard} />
          <Stack.Screen name={pages.emicard} component={Card} />
        </Stack.Navigator>
      </NavigationContainer>
    </NavigationIndependentTree>
  )
}

export default JioFinanceHubStack
